import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeedbackRequestListSliceProps, SendRequest } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getAllSendRequestsByMember = createAsyncThunk(
  "admin/feedback/requests/send",
  async (params: FeedbackRequestListSliceProps, storeActions) => {
    const url = `api/v1/admin/member/requests/sent?memberId=${params.memberId}&offSet=${params.offSet}&count=${params.count}&status=${params.status}&requestTag=${params.tag}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const allSendRequestsByMemberSlice = createSlice({
  name: "allSendRequestsByMember",
  initialState: {
    status: null as number | null,
    text: null as string | null,
    data: null as Array<SendRequest> | null,
    loading: false as boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSendRequestsByMember.fulfilled, (state, action) => {
      state.status = action.payload.status;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
      state.loading = false;
    });
    builder.addCase(getAllSendRequestsByMember.pending, (state) => {
      state.loading = true;
      state.status = null;
      state.text = null;
      state.data = null;
    });
    builder.addCase(getAllSendRequestsByMember.rejected, (state) => {
      state.status = 503;
      state.text = null;
      state.data = null;
      state.loading = false;
    });
  },
});

export const { clearData } = allSendRequestsByMemberSlice.actions;

export default allSendRequestsByMemberSlice;
